const THEME_TYPES = {
  DARK: "DARK",
  LIGHT: "LIGHT",
};

export default THEME_TYPES;
